import React from "react";
import styled from "styled-components";

interface IProps extends React.HTMLAttributes<HTMLParagraphElement> {}
const Text: React.FC<IProps> = ({ ...props }) => <P {...props} />;

export default Text;

const P = styled.p``;
